export default __webpack_public_path__ + "static/media/logo-2.4416cf2c.png";